import type { AnyObject } from "antd/es/_util/type";
import type { TableWrapperProps } from "../../../common/components/Table";
import { componentActions } from "../../../features/component/componentSlice";
import type { TurbineData } from "./TurbineViewRender";
import { FileAddOutlined } from "@ant-design/icons";
import type { TurbineComponent } from "../../generated-axios-client";
import { EditableText, editableTypes } from "../../../common/components/EditableText";
import { dateValue } from "../../../common/columns";
import { ticketActions } from "../../../features/ticket/ticketSlice";
import { TableActions } from "../../../common/components/TableActions";
import { actions as routerActions } from "redux-router5";
import { routeNames } from "../../common/routes";
import {
  componentTypeMessageId,
  isBlade,
  sortComponents,
} from "../../../common/utils/componentLabel";

export const componentTableRender: TableWrapperProps<TurbineData, AnyObject>["getRows"] = (
  intl,
  dispatch,
  turbineData,
  modalApi
) => {
  const { components, turbine } = turbineData;

  const onChange = (id: string) => (name: string, value: string) => {
    dispatch(componentActions.componentEdit({ id: id, data: { [name]: value } }));
  };

  const prefilTicket = (client?: string, turbine?: string, component?: string) => {
    dispatch(
      ticketActions.setInitialValue({
        client: client,
        turbine: turbine,
        items: [{ component: component }],
      })
    );
    dispatch(
      routerActions.navigateTo(routeNames.TICKET_CREATE, {
        client: client,
        turbine: turbine,
      })
    );
  };

  // The list endpoint returns a plain array unless sideloading was requested.
  const componentList: TurbineComponent[] = Array.isArray(components.results)
    ? components.results
    : (components.results.component ?? []);

  return sortComponents(componentList).map((component) => {
    return {
      key: component.id,
      component_type: intl.formatMessage({
        id: componentTypeMessageId(component.component_type),
      }),
      serial_number: (
        <EditableText
          variableName="serial_number"
          variableValue={component.serial_number ? component.serial_number : undefined}
          intl={intl}
          dataType={editableTypes.TEXT}
          onChange={component.id ? onChange(component.id) : undefined}
        />
      ),
      manufacturer: (
        <EditableText
          variableName="manufacturer"
          variableValue={component.manufacturer ? component.manufacturer : undefined}
          intl={intl}
          dataType={editableTypes.TEXT}
          onChange={component.id ? onChange(component.id) : undefined}
        />
      ),
      model: (
        <EditableText
          variableName="model"
          variableValue={component.model ? component.model : undefined}
          intl={intl}
          dataType={editableTypes.TEXT}
          onChange={component.id ? onChange(component.id) : undefined}
        />
      ),
      set_number: isBlade(component) ? (
        <EditableText
          variableName="set_number"
          variableValue={component.set_number ? component.set_number : undefined}
          intl={intl}
          dataType={editableTypes.TEXT}
          onChange={component.id ? onChange(component.id) : undefined}
        />
      ) : (
        "—"
      ),
      created_at: component.created_at ? dateValue(component.created_at, intl) : "—",
      updated_at: component.updated_at ? dateValue(component.updated_at, intl) : "—",
      actions: (
        <TableActions
          actions={[
            {
              key: "create-work-order",
              icon: <FileAddOutlined />,
              onClick: () => prefilTicket(turbine.client.id, turbine.id, component.id),
              tooltip: "Create Work Order",
            },
          ]}
        />
      ),
    };
  });
};
